<template>
  <Card class="mb-5" additional-classes=" p-md-0 ps-md-4 pe-md-0 py-md-0">
    <section class="row p-4 p-md-0">
      <div
        class="text-center text-md-start col-12 col-md-4 d-flex flex-column py-md-4 gap-md-4"
      >
        <div class="icon">
          <slot name="icon"></slot>
        </div>
        <div class="title">
          <h4 class="title-4 text-primary-blue">
            {{ t(props.titleKey) }}
          </h4>
        </div>
        <div class="description">
          <p class="body text-grey-900">
            {{ t(props.descriptionKey) }}
          </p>
        </div>
        <div class="button">
          <Button
            @button-click="handleClick"
            :classes="['w-100', 'h-100', 'button-primary', 'bg-primary-blue']"
          >
            <template #text>
              <span>{{ t('reservations.search') }}</span>
            </template>
          </Button>
        </div>
      </div>
      <div class="image-container d-none d-md-block col-md-8">
        <img :src="placeholderImage" alt="placeholder" />
      </div>
    </section>
  </Card>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  // UI components
  import Card from '@/components/UI/Card.vue'
  import Button from '@/components/UI/Button.vue'
  import { useDomainRedirect } from '@/composables/useDomainRedirect'
  import YoonlyService from '@/services/YoonlyService'

  // Images
  import bookingPlaceHolder from '@/assets/bookingPlaceHolder.png'
  import bookingPlaceHolderYoonly from '@/assets/YN-booking-placeholder.jpg'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  const props = withDefaults(
    defineProps<{
      titleKey?: string
      descriptionKey?: string
    }>(),
    {
      titleKey: 'reservations.noBooking',
      descriptionKey: 'reservations.timeToChoose',
    }
  )

  const placeholderImage = computed(() =>
    new YoonlyService().isYoonly ? bookingPlaceHolderYoonly : bookingPlaceHolder
  )

  // Use the custom redirect composable
  const { handleRedirect } = useDomainRedirect()
  // Updated handleClick method
  const handleClick = (): void => {
    handleRedirect('/se-results', { source: 'my-account' })
  }
</script>

<style scoped>
  .image-container {
    line-height: 0;
    overflow: hidden;
  }

  img {
    display: block;
    /* Subpixel hairline fix; 0.1px often rounds to 0 — use 0.5px if needed */
    width: calc(100% + 0.1px);
    max-width: none;
    height: 100%;
    border-radius: var(--border-radius-default);
  }
</style>
